import { getLatesUnepCertificateThunkAction } from "./getLatesUnepCertificate.thunk.action";

import $api from "../../../../../services/axiosService";
import { deleteUnepIssueAction } from "../deleteUnepIssue.action";
import countly from "../../../../../../analytics/countly";
import { EVENT_NAMES } from "../../../../../../analytics/events";

export const approveCertificateBySmsThunkAction = (code, issueId, props) => async (dispatch) => {
    try {
        props.setLoader(true);
        const response = await $api.post(`v1/c/certificates/issues/${issueId}/confirm/sms/${code}`);
        switch (response.status) {
        case 200:
            props.setPhoneToggle(false);
            props.setLoader(false);
            countly.event(EVENT_NAMES.UNEP_CERTIFICATE_ISSUED, { pid: localStorage.getItem("pid") });
            dispatch(getLatesUnepCertificateThunkAction());
            return props.setDescription("Сертификат УНЭП будет выпущен в течение 2-3 минут");
        default:
            return true;
        }
    } catch (e) {
        props.setLoader(false);
        if (e?.response?.status) {
            return props.setAuthNumber(e?.response?.data?.detail);
        }

        dispatch(deleteUnepIssueAction());

        return props.setDescription(e?.response?.data?.detail);
    }
};
